export default "__VITE_ASSET__CR4Xywlw__"